import React from "react";
import Button from "../../components/ui/Button";
import Header from "../../components/common/Header";

const HeroSection = () => {
  return (
    <section className="w-full bg-[#ffffff]">
      <div className="w-full max-w-[1920px] mx-auto">
        <div className="relative w-full h-[650px] md:h-[800px] lg:h-[1298px]">
          {/* Background Image */}
          <img
            src="/assets/utpannProduction/Bgcolor.png"
            alt="background"
            className="absolute top-0 right-0 w-[58%] h-[560px] md:h-[700px] lg:h-[1120px] object-cover"
          />

          <Header />

          {/* Main Content */}
          <div className="relative z-10 flex flex-col items-center gap-[10px] md:gap-[20px] mt-[80px] md:mt-[120px] lg:mt-[163px] px-4 md:px-[28px] lg:px-[56px]">
            <h1 className="text-[30px] md:text-[60px] lg:text-[100px] font-parkinsans font-bold leading-[42px] md:leading-[84px] lg:leading-[140px] text-center text-[#343163] max-w-5xl">
              Utpann Network
            </h1>

            <p className="text-[14px] md:text-[18px] lg:text-[24px] font-poppins font-light leading-[22px] md:leading-[28px] lg:leading-[38px] text-center text-[#1b0e02] max-w-6xl">
              UTPANN Network is supported by a strong and expanding distribution
              system across Gujarat. With 250+ authorized distributors, we
              ensure timely availability and consistent supply of UTPANN organic
              fertilizers. This robust network enables us to effectively serve
              farmers, agri-input dealers, and institutional customers.
            </p>
            <div className="hero-animated-item">
              <Button
                text="Learn More"
                text_font_size="text-[16px] sm:text-[20px] xl:text-[24px]"
                text_font_family="Parkinsans"
                text_font_weight="font-semibold"
                text_line_height="leading-[23px] sm:leading-[28px] xl:leading-[34px]"
                text_text_align="center"
                text_color="#1c233a"
                border_border="1px solid #1c233a"
                border_border_radius="rounded-[50px]"
                layout_width="auto"
                padding="t=12px,r=32px,b=12px,l=32px"
                className=" transition-colors duration-300"
              />
            </div>
          </div>

          {/* Bottom Image */}
          <div className="absolute bottom-0 left-0 w-full">
            <img
              src="/assets/utpannProduction/UtpannProductionBG.png"
              alt="farming background"
              className="w-full h-[200px] md:h-[400px] lg:h-[640px] object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
